/**
 * Navigation Component
 * Top navigation bar with links; shows account info / logout when logged in
 */

import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAdmin, logout } = useAuth();
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
  };

  const handleLogout = async () => {
    await logout();
    setExpanded(false);
    navigate('/login');
  };

  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup' || location.pathname === '/admin-login';

  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={handleNavClick}>
          <i className="bi bi-house-fill me-2"></i> Auto Parking
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-lg-center">
            {user && (
              <>
                <Nav.Link
                  as={Link}
                  to="/dashboard"
                  active={location.pathname === '/dashboard'}
                  onClick={handleNavClick}
                >
                  Dashboard
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/parking-history"
                  active={location.pathname === '/parking-history'}
                  onClick={handleNavClick}
                >
                  History
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/usage-chart"
                  active={location.pathname === '/usage-chart'}
                  onClick={handleNavClick}
                >
                  Usage Chart
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/settings"
                  active={location.pathname === '/settings'}
                  onClick={handleNavClick}
                >
                  Settings
                </Nav.Link>
                <Navbar.Text className="text-light ms-lg-3 me-2 d-none d-lg-inline">
                  <i className="bi bi-person-circle me-1"></i>
                  {user.tenant}
                </Navbar.Text>
                <Button variant="outline-light" size="sm" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-1"></i> Logout
                </Button>
              </>
            )}

            {isAdmin && (
              <>
                <Nav.Link
                  as={Link}
                  to="/admin3398"
                  active={location.pathname === '/admin3398'}
                  onClick={handleNavClick}
                >
                  Admin
                </Nav.Link>
                <Navbar.Text className="text-light ms-lg-3 me-2">
                  <i className="bi bi-shield-lock me-1"></i> Admin
                </Navbar.Text>
                <Button variant="outline-light" size="sm" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-1"></i> Logout
                </Button>
              </>
            )}

            {!user && !isAdmin && !isAuthPage && (
              <Nav.Link as={Link} to="/login" onClick={handleNavClick}>
                <i className="bi bi-box-arrow-in-right me-1"></i> Login
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
